import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=0d51e76a&scoped=true&lang=pug"
import script from "./Banner.vue?vue&type=script&lang=ts"
export * from "./Banner.vue?vue&type=script&lang=ts"
import style0 from "./Banner.vue?vue&type=style&index=0&id=0d51e76a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d51e76a",
  null
  
)

export default component.exports